// extracted by mini-css-extract-plugin
module.exports = {"loginFooter":"styles__loginFooter___XUCVQ"};